import { render, staticRenderFns } from "./Campuses.vue?vue&type=template&id=944b94be&scoped=true"
import script from "./Campuses.vue?vue&type=script&lang=ts"
export * from "./Campuses.vue?vue&type=script&lang=ts"
import style0 from "./Campuses.vue?vue&type=style&index=0&id=944b94be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944b94be",
  null
  
)

export default component.exports